import * as React from 'react';
import { observer } from 'mobx-react-lite';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import SummaryRow from './SummaryRow';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';

const styles = require('./MeetingMessageSummary.scss');

export interface MeetingRequestSummaryProps {
    item: MeetingRequestMessageType;
}

const MeetingRequestSummary = observer(function MeetingRequestSummary(
    props: MeetingRequestSummaryProps
) {
    const { item } = props;

    if (item.MeetingRequestType == 'NewMeetingRequest') {
        return <SummaryRow item={item} />;
    } else {
        const {
            HasLocationChanged,
            HasEndTimeChanged,
            HasStartTimeChanged,
            HasSubjectChanged,
        } = item.ChangeHighlights;
        const HasTimeChanged = HasEndTimeChanged || HasStartTimeChanged;

        const hasContent = HasSubjectChanged || HasTimeChanged || HasLocationChanged;

        return (
            <SummaryRow item={item}>
                {hasContent && (
                    <div className={styles.contentContainer}>
                        {HasSubjectChanged && <div>{item.Subject}</div>}
                        {HasTimeChanged && (
                            <div>
                                {formatMeetingTimeSpan(
                                    item.Start,
                                    item.End,
                                    !item.RecurrenceId /* ideally we would check CalendarItemType but it seems broken */
                                        ? item.Recurrence
                                        : undefined /* recurrenceId indicates instance */
                                )}
                                <span className={styles.oldValue}>
                                    {formatMeetingTimeSpan(
                                        item.ChangeHighlights.Start || item.Start,
                                        item.ChangeHighlights.End || item.End,
                                        item.Recurrence
                                    )}
                                </span>
                            </div>
                        )}
                        {HasLocationChanged && (
                            <div>
                                {item.Location && <span>{item.Location.DisplayName}</span>}
                                <span className={styles.oldValue}>
                                    {item.ChangeHighlights.Location}
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </SummaryRow>
        );
    }
});

export default MeetingRequestSummary;
